/**
 * Regional Translations Module (Portuguese)
 * Matches English structure exactly
 * @module regional
 * @language pt
 */

export const regional = {
  regional: {
    title: "Análise Regional",
    subtitle: "Membros ativos por região geográfica",
    asiaPacific: "Ásia e o Pacífico",
    europe: "Europa",
    americas: "América",
    africaMiddleEast: "África e Oriente Médio"
  },
  regionalAnalysisPage: {
    pageSubtitle: "1.000+ projetos • 148.122 membros • 4.641 Organizações Locais em 4 regiões JCI"
  },
  regionalDistribution: {
    title: "Distribuição Regional",
    subtitle: "1.000+ projetos em 4 regiões JCI em 2024-2025",
    totalMembers: "Total de Membros",
    localOrganizations: "Organizações Locais",
    countries: "Países",
    annualProjects: "Projetos Anuais",
    projectDistributionTitle: "Distribuição de Projetos por Região (2024-2025)",
    projects: "projetos",
    risePillarTitle: "Distribuição de Pilares JCI RISE",
    total: "Total",
    mentalHealth: "Saúde Mental",
    mentalHealthBeneficiaries: "5,9M+ beneficiários alcançados",
    workforceResilience: "Resiliência da Força de Trabalho",
    workforceDesc: "Habilidades e apoio ao emprego",
    economicRecovery: "Recuperação Econômica",
    economicDesc: "Empreendedorismo e crescimento econômico",
    totalBeneficiaries: "Total de beneficiários alcançados através de 1000+ projetos JCI",
    membershipDistributionTitle: "Distribuição de Membros por Região",
    fiiScore: "Pontuação FII",
    members: "Membros",
    localOrgs: "Orgs Locais",
    projectShare: "Participação em Projetos",
    fastest: "Mais Rápido",
    emerging: "Emergente",
    stable: "Estável",
    consolidating: "Consolidando",
    sourceNote: "Fonte: Relatório de Impacto JCI 2025 - Dados regionais oficiais"
  },
  regionalFIIAnalysis: {
    title: "Análise Regional do FII",
    regionalComparison: "Comparação Regional do FII",
    fiiScore: "Pontuação FII",
    gapBestWorst: "Lacuna entre melhor e pior",
    gapIndicates: "Esta lacuna indica desigualdade global significativa na oportunidade dos jovens",
    bestPerforming: "MELHOR DESEMPENHO",
    mixedPerformance: "DESEMPENHO MISTO",
    equityFocusNeeded: "FOCO EM EQUIDADE NECESSÁRIO",
    highestOpportunity: "MAIOR OPORTUNIDADE",
    countriesWithData: "Países com dados",
    mentalHealth: "Saúde Mental",
    workforce: "Força de Trabalho",
    entrepreneurship: "Empreendedorismo",
    strengths: "Forças",
    challenges: "Desafios",
    recommendations: "Recomendações",
    jciOpportunity: "Oportunidade JCI",
    members: "membros",
    localOrgs: "orgs locais"
  },
  regionalFII: {
    title: "Comparação Regional do FII",
    fiiScore: "Pontuação FII",
    gapIndicator: "Lacuna entre melhor e pior",
    points: "pontos",
    gapDescription: "Esta lacuna indica desigualdade global significativa na oportunidade dos jovens",
    mentalHealth: "Saúde Mental",
    workforce: "Força de Trabalho",
    entrepreneurship: "Empreendedorismo",
    countriesWithData: "Países com Dados",
    strengths: "Forças",
    challenges: "Desafios",
    recommendations: "Recomendações",
    jciOpportunity: "Oportunidade JCI",
    members: "Membros",
    localOrgs: "Orgs Locais",
    regions: {
      europe: "Europa",
      asiaPacific: "Ásia e o Pacífico",
      americas: "América",
      africaMe: "África e Oriente Médio"
    },
    status: {
      bestPerforming: "Melhor Desempenho",
      mixedPerformance: "Desempenho Misto",
      equityFocus: "Foco em Equidade Necessário",
      highestOpportunity: "Maior Oportunidade"
    },
    europe: {
      strength1: "Acesso a Serviços de Saúde Mental: 77/100",
      strength2: "Qualidade da força de trabalho: 76/100",
      strength3: "Prevenção de suicídio: 73/100",
      strength4: "Apoio político: Integração universal de saúde",
      challenge1: "Redução de estigma necessária",
      challenge2: "Bolsões de desemprego juvenil",
      challenge3: "Apoio ao empreendedorismo poderia ser mais forte",
      recommendation1: "Expandir acesso digital à saúde mental",
      recommendation2: "Aumentar intervenção precoce",
      recommendation3: "Apoiar mulheres empreendedoras",
      insight: "Europa lidera → modelo para outras regiões",
      expansion: "Considerar expansão para 50+ organizações"
    },
    asiaPacific: {
      strength1: "Crescimento econômico: Forte ambiente de negócios",
      strength2: "Empreendedorismo: Maiores taxas de estágio inicial",
      strength3: "Adoção de tecnologia: Transformação digital mais rápida",
      strength4: "Ecossistema de unicórnios",
      challenge1: "Alta disparidade: lacuna de 40 pontos",
      challenge2: "Acesso à saúde mental: Apenas 30-50%",
      challenge3: "Lacuna de habilidades",
      challenge4: "Bolsões de desemprego",
      recommendation1: "Priorizar saúde mental",
      recommendation2: "Fechar lacuna de habilidades com treinamento JCI",
      recommendation3: "Escalar projetos RISE",
      insight: "70% da JCI global = presença forte",
      expansion: "Sudeste Asiático está mal atendido"
    },
    americas: {
      strength1: "Empreendedorismo: 24-28% taxas de estágio inicial",
      strength2: "Educação: 45%+ matrícula terciária",
      strength3: "América do Norte: Infraestrutura MH forte",
      challenge1: "Lacuna Norte-Sul: 34 pontos",
      challenge2: "América Latina: Acesso MH 20-40%",
      challenge3: "Desigualdade econômica",
      challenge4: "Lacuna de gênero",
      recommendation1: "Focar na expansão RISE da América Latina",
      recommendation2: "Construir apoio a mulheres empreendedoras",
      recommendation3: "Expandir treinamento de habilidades digitais",
      insight: "Apenas 8% da JCI global mas 15% do mundo = POTENCIAL DE CRESCIMENTO",
      expansion: "Escalar de 90 projetos RISE → 150+"
    },
    africaMe: {
      strength1: "População jovem: Região mais jovem (média 29 anos)",
      strength2: "Aspiração empreendedora: 52% dos jovens querem iniciar negócios",
      strength3: "Potencial de crescimento: 10-20% crescimento anual do PIB (algumas regiões)",
      strength4: "Salto digital: Adoção mobile-first",
      challenge1: "Acesso à saúde mental: Apenas 10-30% (UE é 70%)",
      challenge2: "Infraestrutura de saúde: Escassez crítica",
      challenge3: "Desemprego juvenil: 14-16% (global é 13%)",
      challenge4: "Lacuna de financiamento de $1,7T, 30% é África/OM",
      challenge5: "Lacuna de gênero: Acesso desigual a educação e oportunidades",
      challenge6: "Fuga de cérebros: Emigração de jovens qualificados",
      limitedData: "Limitado: 18 dos 54 países africanos com dados completos",
      recommendation1: "Implementar modelo de saúde mental de suporte por pares (não clínico)",
      recommendation2: "Escalar treinamento de habilidades STEM + digital via JCI",
      recommendation3: "Expandir microfinanças + mentoria para empreendedorismo juvenil",
      recommendation4: "Focar em programas de empoderamento de gênero",
      insight: "Lacuna FII: 22 pontos vs Europa = abordável. Região de expansão crítica",
      expansion: "Escalar projetos JCI RISE 3x"
    }
  },
  regionalMap: {
    title: "Distribuição Regional de Membros",
    subtitle: "Clique em uma região para explorar detalhes",
    resetView: "Redefinir Visualização",
    members: "Membros",
    localOrgs: "Orgs Locais",
    growth: "Crescimento",
    regions: {
      asiaPacific: "Ásia e o Pacífico",
      europe: "Europa",
      africaMe: "África e Oriente Médio",
      americas: "América"
    },
    growthStatus: {
      fastest: "Crescimento Mais Rápido",
      stable: "Estável",
      emerging: "Potencial Emergente",
      consolidating: "Consolidando"
    }
  }
} as const;
